import CryptoJS from 'crypto-js';
import sha256 from 'js-sha256';
import conf from '../config';

var key  = CryptoJS.enc.Latin1.parse(sha256(sha256(conf.encrypted_key)).substring(0,16));
// var iv   = CryptoJS.enc.Latin1.parse('abcdef0123456789');

// 加密
function EncryptData(data) {
    var srcs = CryptoJS.enc.Utf8.parse(data);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode : CryptoJS.mode.ECB,
        padding : CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

// 解密
function DecryptData(data) {
    var stime = new Date().getTime();
    var decrypt = CryptoJS.AES.decrypt(data, key, {
        mode : CryptoJS.mode.ECB,
        padding : CryptoJS.pad.Pkcs7
    });
    var result = JSON.parse(CryptoJS.enc.Utf8.stringify(decrypt).toString());
    var etime = new Date().getTime();
    // console.log("DecryptData Time:" + (etime - stime));
    return result;
}

export default {
    EncryptData:EncryptData,
    DecryptData:DecryptData,
}


// WEBPACK FOOTER //
// ./src/communal/encrypt.js